module.exports = __webpack_public_path__ + "img/westudy_online_screens.cd245a8e.png";